export default __webpack_public_path__ + "static/mlb-3a390e7ae862895ac97cf0fb556130c0.png";